import React from 'react';

function LinearScale(props) {
    return (
        <div></div>
    );
}

export default LinearScale;